import { createAction } from '@reduxjs/toolkit';

import { NAME } from './constants';

export const playAudio = createAction(`${NAME}/playAudio`);
export const pauseAudio = createAction(`${NAME}/pauseAudio`);
export const stopAudio = createAction(`${NAME}/stopAudio`);
